namespace TabAurous.ECommerce {
    export interface ReceiptForm {
        Date: Serenity.DateEditor;
        VoucherNo: Serenity.StringEditor;
        POSCustomerId: Serenity.ServiceLookupEditor;
        IsAdvance: Serenity.BooleanEditor;
        RefNo: Serenity.StringEditor;
        RefDate: Serenity.DateEditor;
        EnteredBy: Serenity.StringEditor;
        CurrencyId: Serenity.LookupEditor;
        ReceiptDetails: ReceiptDetailsEditor;
        PartyBalance: Finance.PartyBalanceEditor;
        UserId: Serenity.DecimalEditor;
        KnockOffTotal: Serenity.DecimalEditor;
        TotalAmount: Serenity.DecimalEditor;
        Narration: Serenity.StringEditor;
    }

    export class ReceiptForm extends Serenity.PrefixedContext {
        static formKey = 'ECommerce.Receipt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReceiptForm.init)  {
                ReceiptForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.ServiceLookupEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.LookupEditor;
                var w5 = ReceiptDetailsEditor;
                var w6 = Finance.PartyBalanceEditor;
                var w7 = s.DecimalEditor;

                Q.initFormType(ReceiptForm, [
                    'Date', w0,
                    'VoucherNo', w1,
                    'POSCustomerId', w2,
                    'IsAdvance', w3,
                    'RefNo', w1,
                    'RefDate', w0,
                    'EnteredBy', w1,
                    'CurrencyId', w4,
                    'ReceiptDetails', w5,
                    'PartyBalance', w6,
                    'UserId', w7,
                    'KnockOffTotal', w7,
                    'TotalAmount', w7,
                    'Narration', w1
                ]);
            }
        }
    }
}
